import { useState } from 'react'
import { CurecallButton, ECurecallButtonAppearance, CurecallCheckbox } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'

type Props = {
  backupCodes: string[]
  onAcknowledge: () => void
}

export default function TwoFactorBackupCodes({ backupCodes, onAcknowledge }: Props) {
  const { t } = useTranslation()
  const [hasSaved, setHasSaved] = useState(false)

  const handleCopyAll = () => {
    navigator.clipboard.writeText(backupCodes.join('\n'))
  }

  const handleDownload = () => {
    const content = backupCodes.join('\n')
    const blob = new Blob([content], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'curecall-backup-codes.txt'
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div className="c-flex c-flex-col c-gap-6">
      <p className="c-text-sm c-text-gray-600">{t('pages.auth.account.two-factor.backup-codes-warning')}</p>

      <div className="c-grid c-grid-cols-2 c-gap-2 c-p-4 c-bg-gray-50 c-rounded-md c-font-mono c-text-sm">
        {backupCodes.map((code) => (
          <span key={code} className="c-text-center c-py-1">
            {code}
          </span>
        ))}
      </div>

      <div className="c-flex c-gap-3 c-justify-center">
        <CurecallButton appearance={ECurecallButtonAppearance.SECONDARY} onClick={handleCopyAll}>
          {t('pages.auth.account.two-factor.copy-all')}
        </CurecallButton>
        <CurecallButton appearance={ECurecallButtonAppearance.SECONDARY} onClick={handleDownload}>
          {t('pages.auth.account.two-factor.download')}
        </CurecallButton>
      </div>

      <div className="c-flex c-items-center c-gap-2">
        <CurecallCheckbox
          isByDefaultChecked={hasSaved}
          onChange={(e) => setHasSaved(e.target.checked)}
          label={t('pages.auth.account.two-factor.backup-codes-saved')}
        />
      </div>

      <CurecallButton onClick={onAcknowledge} isDisabled={!hasSaved}>
        {t('common.actions.confirm')}
      </CurecallButton>
    </div>
  )
}
